import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WebHookService {

	private webHook = 'https://webexapis.com/v1/webhooks/incoming/Y2lzY29zcGFyazovL3VzL1dFQkhPT0svOGMwMmZlZDQtNWM0OC00Y2YzLTliYmYtMjE1MmQ4ODJkMTQy';
    private options = {
        headers: new HttpHeaders(
          { 'Content-Type': 'application/json'}
        )
    };

    constructor(private http: HttpClient) { }

    postError(message:string, stack:string): void {

        const messageToSend = {
            "markdown" : message 
        }
		alert(JSON.stringify(messageToSend));
        this.http.post<any>(this.webHook,JSON.stringify(messageToSend), this.options).subscribe();
    }
}
